import { submitFormData } from "./api";
import { SOURCE_LEAVE, SOURCE_SUBMIT } from "./Subscription";

export const UPDATE_FIELD = "UPDATE_FIELD";
export const UPDATE_FORM = "UPDATE_FORM";
export const RECEIVE_SUBMIT_FORM = "RECEIVE_SUBMIT_FORM";
export const REQUEST_SUBMIT_FORM = "REQUEST_SUBMIT_FORM";
export const RECEIVE_CLEAN_FORM = "RECEIVE_CLEAN_FORM";
export const RECEIVE_EMAIL_DOMAIN_BLOCKED = "RECEIVE_EMAIL_DOMAIN_BLOCKED";
export const RECEIVE_ERROR = "RECEIVE_ERROR";
export const RECEIVE_RECAPTCHA_TOKEN = "RECEIVE_RECAPTCHA_TOKEN";
export const RECEIVE_REDIRECT = "RECEIVE_REDIRECT";
export const RECEIVE_STEPS_COUNT = "RECEIVE_STEPS_COUNT";
export const RECEIVE_USER_EXISTS = "RECEIVE_USER_EXISTS";
export const UPDATE_TO_PREV_STEP = "UPDATE_TO_PREV_STEP";

export function updateField(fieldKey, value) {
	return {
		type: UPDATE_FIELD,
		data: { fieldKey, value },
	};
}

export function updateForm(data) {
	return {
		type: UPDATE_FORM,
		data,
	};
}

export function updateToPrevStep() {
	return {
		type: UPDATE_TO_PREV_STEP,
	};
}

export function requestSubmitForm() {
	return {
		type: REQUEST_SUBMIT_FORM,
	};
}

export function receiveSubmitForm() {
	return {
		type: RECEIVE_SUBMIT_FORM,
	};
}

export function setCleanForm() {
	return {
		type: RECEIVE_CLEAN_FORM,
	};
}

export function setEmailDomainBlocked(data) {
	return {
		type: RECEIVE_EMAIL_DOMAIN_BLOCKED,
		data,
	};
}

export function setError(error) {
	return {
		type: RECEIVE_ERROR,
		data: { error },
	};
}

export function setRecaptchaToken(token) {
	return {
		type: RECEIVE_RECAPTCHA_TOKEN,
		data: token,
	};
}

export function setRedirect() {
	return {
		type: RECEIVE_REDIRECT,
	};
}

export function setStepsCount(data) {
	return {
		type: RECEIVE_STEPS_COUNT,
		data,
	};
}

export function setUserExists(data) {
	return {
		type: RECEIVE_USER_EXISTS,
		data,
	};
}

export const submitForm = (source, namespace) => {
	return (dispatch, getState) => {
		const state = getState();
		const onLeaveRequest = source === SOURCE_LEAVE;
		const onSubmitRequest = source === SOURCE_SUBMIT;

		if (onLeaveRequest && (!state.form.email || state.emailDomainBlocked)) {
			return;
		}

		const payload = Object.assign(
			{},
			state.form,
			{ "g-recaptcha-response": state.recaptchaToken },
			{ source },
		);

		onSubmitRequest && dispatch(requestSubmitForm());

		submitFormData(
			namespace,
			payload,
			() => onSubmitRequest && dispatch(receiveSubmitForm()),
			(error) => onSubmitRequest && dispatch(setError(error.message)),
		);
	};
};
